import { configure } from 'vee-validate';
import { datetimeFormats } from '~/utils/date-time-formats';

function loadLocaleMessages() {
  const locales = require.context(
    'static/locales',
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );
  const messages = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

export default function ({ app }) {
  configure({
    defaultMessage: (field, values) => {
      values._field_ = app.i18n.t(`fields.${field}`);
      if (values.targetField) {
        values.targetField = app.i18n.t(`fields.${values.targetField}`);
      }
      if (values.targetField1) {
        values.targetField1 = app.i18n.t(`fields.${values.targetField1}`);
      }
      if (values.targetField2) {
        values.targetField2 = app.i18n.t(`fields.${values.targetField2}`);
      }
      return app.i18n.t(`validations.${values._rule_}`, values);
    }
  });
  return {
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
    messages: loadLocaleMessages(),
    silentTranslationWarn: true,
    datetimeFormats
  };
}
